export const DrawerViewConstants = {
  // Email-related views (used by EmailDrawerContent)
  SEND_EMAIL: 'sendEmail',
  VIEW_ALL_EMAIL_LIST: 'viewAllEmailList',
  VIEW_RECORD_EMAIL_LIST: 'viewRecordEmailList',

  // Note-related views (used by NoteDrawerContent)
  ADD_NOTE: 'addNote',
  VIEW_NOTE_HISTORY: 'viewNoteHistory',

  // Status and feedback views
  STATUS_CHANGE: 'statusChange',
  FEEDBACK: 'feedBack',

  // Component-specific views
  FULL_HISTORY: 'fullHistory',        // Activity
  EVALUATION: 'evaluation',            // Course
  VIEW: 'view',                        // RPL
  APPROVE: 'approve',                  // RPL
  VIEW_INVOICE_HISTORY: 'invoiceHistory',  // Member
  VIEW_MEMBER_DETAILS: 'viewMemberDetails', // Member
} as const;

// Type helpers for each component
export type EmailDrawerViews = 
  | typeof DrawerViewConstants.SEND_EMAIL
  | typeof DrawerViewConstants.VIEW_ALL_EMAIL_LIST
  | typeof DrawerViewConstants.VIEW_RECORD_EMAIL_LIST;

export type NoteDrawerViews = 
  | typeof DrawerViewConstants.ADD_NOTE
  | typeof DrawerViewConstants.VIEW_NOTE_HISTORY;

export type ActivityDrawerViews = 
  | EmailDrawerViews
  | NoteDrawerViews
  | typeof DrawerViewConstants.FULL_HISTORY
  | typeof DrawerViewConstants.STATUS_CHANGE
  | typeof DrawerViewConstants.VIEW_MEMBER_DETAILS;

export type CourseDrawerViews = 
  | EmailDrawerViews
  | NoteDrawerViews
  | typeof DrawerViewConstants.EVALUATION
  | typeof DrawerViewConstants.FEEDBACK
  | typeof DrawerViewConstants.VIEW_INVOICE_HISTORY
  | typeof DrawerViewConstants.VIEW_MEMBER_DETAILS;

export type MemberDrawerViews = 
  | EmailDrawerViews
  | NoteDrawerViews
  | typeof DrawerViewConstants.FEEDBACK
  | typeof DrawerViewConstants.VIEW_INVOICE_HISTORY
  | typeof DrawerViewConstants.VIEW_MEMBER_DETAILS;

export type MemberEndorsementDrawerViews = 
  | EmailDrawerViews
  | NoteDrawerViews
  | typeof DrawerViewConstants.FEEDBACK
  | typeof DrawerViewConstants.VIEW_MEMBER_DETAILS;

export type RplDrawerViews = 
  | EmailDrawerViews
  | NoteDrawerViews
  | typeof DrawerViewConstants.VIEW
  | typeof DrawerViewConstants.FEEDBACK
  | typeof DrawerViewConstants.VIEW_INVOICE_HISTORY
  | typeof DrawerViewConstants.VIEW_MEMBER_DETAILS;

export type ScoreDrawerViews = 
  | EmailDrawerViews
  | NoteDrawerViews
  | typeof DrawerViewConstants.FEEDBACK
  | typeof DrawerViewConstants.VIEW_MEMBER_DETAILS;

export type RangeDrawerViews = 
  | EmailDrawerViews
  | typeof DrawerViewConstants.FEEDBACK;